import _defineProperty from "D:/FOTA/FOTAWeb/FOTAmanager/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.constructor";

var _myfunction;

import bus from "./bus.js";
var myfunction = (_myfunction = {
  mytoFixed: function mytoFixed(number, fractionDigits) {
    var times = Math.pow(10, fractionDigits);
    var roundNum = Math.round(number * times) / times;
    var a = roundNum.toFixed(fractionDigits);
    console.log(a);
    return a;
  },
  mytoFixedFloor: function mytoFixedFloor(number) {
    var a = Math.floor(number);
    console.log(a);
    return a;
  },
  checkNumber: function checkNumber(number) {
    var numReg = /^[0-9]*$/;
    var numRe = new RegExp(numReg);

    if (!numRe.test(number)) {
      return false;
    } else {
      return true;
    }
  },
  export2Excel: function export2Excel(columns, list, exclefilename) {
    require.ensure([], function () {
      var _require = require("./excel/Export2Excel"),
          export_json_to_excel = _require.export_json_to_excel;

      var tHeader = [];
      var filterVal = [];
      columns.forEach(function (item) {
        tHeader.push(item.title);
        filterVal.push(item.key);
      });
      var data = list.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
      export_json_to_excel(tHeader, data, exclefilename);
    });
  },
  importExe: function importExe(event, mythis, callBack) {
    if (!event.target.files.length) {
      return;
    }

    var that = mythis; // 拿取文件对象

    var f = event.target.files[0]; // 用FileReader来读取

    var reader = new FileReader(); // 重写FileReader上的readAsBinaryString方法

    FileReader.prototype.readAsBinaryString = function (f) {
      var binary = '';
      var wb; // 读取完成的数据

      var outdata; // 你需要的数据

      var reader = new FileReader();

      reader.onload = function (e) {
        // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
        var bytes = new Uint8Array(reader.result);
        var length = bytes.byteLength;

        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        } // 接下来就是xlsx了，具体可看api


        var XLSX = require('xlsx');

        wb = XLSX.read(binary, {
          type: 'binary'
        });
        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // 自定义方法向父组件传递数据

        console.log('outdata = ' + JSON.stringify(outdata));
        callBack(mythis, outdata);
      };

      reader.readAsArrayBuffer(f);
    };

    reader.readAsBinaryString(f);
  },
  formatDate: function formatDate(numb) {
    var time = new Date((numb - 1) * 24 * 3600000 + 1);
    time.setYear(time.getFullYear() - 70);
    return time;
  },
  outExe: function outExe(columns, exclefilename) {
    require.ensure([], function () {
      var _require2 = require("./excel/Export2Excel"),
          export_json_to_excel = _require2.export_json_to_excel; //引入文件　　　　　　


      var tHeader = [];
      columns.forEach(function (item) {
        tHeader.push(item.title);
      });
      var data = [];
      export_json_to_excel(tHeader, data, exclefilename);
    });
  },
  showtip: function showtip(pageContent, content) {
    pageContent.$alert(content, '提示', {
      confirmButtonText: '确定'
    });
  },
  showtipMessage: function showtipMessage(pageContent, content, types) {
    pageContent.$message({
      message: content,
      type: types
    });
  },
  showtipNoNullMessage: function showtipNoNullMessage(pageContent) {// pageContent.$message({
    // 	message: "*号项不允许为空，请检查数据！",
    // 	type: "warning"
    // });
  }
}, _defineProperty(_myfunction, "showtipNoNullMessage", function showtipNoNullMessage(pageContent, head) {
  pageContent.$message({
    message: head + "不能为空!",
    type: "warning"
  });
}), _defineProperty(_myfunction, "showNoPermissions", function showNoPermissions(pageContent) {
  pageContent.$message({
    message: "权限不足",
    type: "warning"
  });
}), _defineProperty(_myfunction, "isinList", function isinList(str, list) {
  for (var i = 0; i < list.length; i++) {
    if (list[i].name == str) {
      return list[i].id;
    }
  }

  return -1;
}), _defineProperty(_myfunction, "addStr", function addStr(old, str) {
  if (old == "") {
    return str;
  } else {
    return old + ',' + str;
  }
}), _defineProperty(_myfunction, "DatetoStr", function DatetoStr(data, formats) {
  return data.format(formats);
}), _defineProperty(_myfunction, "get00Date", function get00Date(data) {
  var date2 = new Date(data.getTime() - (data.getTime() - data.getTimezoneOffset() * 60000) % (1000 * 60 * 60 * 24));
  return date2;
}), _defineProperty(_myfunction, "file2Bytes", function file2Bytes(file, callBack) {
  var reader = new FileReader(); //设置一个回调函数，等待读取结束后调用

  reader.onload = function (e) {
    var data = e.target.result; //showbox.style.backgroundImage = 'url(' + data + ')';

    callBack(data);
  }; //以url方式读取文件


  reader.readAsDataURL(file);
}), _defineProperty(_myfunction, "base64ToUint8Array", function base64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}), _defineProperty(_myfunction, "stringToByte", function stringToByte(str) {
  var bytes = new Array();
  var len, c;
  len = str.length;

  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i);

    if (c >= 0x010000 && c <= 0x10FFFF) {
      bytes.push(c >> 18 & 0x07 | 0xF0);
      bytes.push(c >> 12 & 0x3F | 0x80);
      bytes.push(c >> 6 & 0x3F | 0x80);
      bytes.push(c & 0x3F | 0x80);
    } else if (c >= 0x000800 && c <= 0x00FFFF) {
      bytes.push(c >> 12 & 0x0F | 0xE0);
      bytes.push(c >> 6 & 0x3F | 0x80);
      bytes.push(c & 0x3F | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007FF) {
      bytes.push(c >> 6 & 0x1F | 0xC0);
      bytes.push(c & 0x3F | 0x80);
    } else {
      bytes.push(c & 0xFF);
    }
  }

  return bytes;
}), _defineProperty(_myfunction, "byteToString", function byteToString(arr) {
  if (typeof arr === 'string') {
    return arr;
  }

  var str = '',
      _arr = arr;

  for (var i = 0; i < _arr.length; i++) {
    var one = _arr[i].toString(2),
        v = one.match(/^1+?(?=0)/);

    if (v && one.length == 8) {
      var bytesLength = v[0].length;

      var store = _arr[i].toString(2).slice(7 - bytesLength);

      for (var st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2);
      }

      str += String.fromCharCode(parseInt(store, 2));
      i += bytesLength - 1;
    } else {
      str += String.fromCharCode(_arr[i]);
    }
  }

  return str;
}), _defineProperty(_myfunction, "StringToHtml", function StringToHtml(str) {
  str = str.replace(/ /g, "+");
  str = str.replace(/%/g, "%25");
  return str;
}), _defineProperty(_myfunction, "goBack", function goBack(pageContent) {
  //pageContent.$router.push('/');
  bus.$emit('close_current_tags');
}), _defineProperty(_myfunction, "noSearchPermissions", function noSearchPermissions(vm) {
  myfunction.showNoPermissions(vm);
  return '/workbench';
}), _defineProperty(_myfunction, "printlog", function printlog() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  console.log(args);
}), _defineProperty(_myfunction, "closeNow", function closeNow() {
  bus.$emit('close_current_tags');
}), _myfunction);

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,
    //month
    "d+": this.getDate(),
    //day
    "h+": this.getHours(),
    //hour
    "m+": this.getMinutes(),
    //minute
    "s+": this.getSeconds(),
    //second
    "q+": Math.floor((this.getMonth() + 3) / 3),
    //quarter
    "S": this.getMilliseconds() //millisecond

  };
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }

  return format;
};

export default myfunction;